import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { useContext } from 'react';
import { OverlayContextProvider, OverlayContextProps, OverlayContext, overlayContextDefaults } from '@wix/da-react-context/pkg/OverlayContext';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
import { useDeviationAttributes } from './useDeviationAttributes';
/** almost same as useContext(OverlayContext), but with correct defaults */ export function useOverlayContext(deviation) {
    const { isFavouritable , isCommentable  } = useDeviationAttributes(deviation, false);
    const deviationType = getDeviationType(deviation);
    const canShowTitle = ![
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE,
        DeviationTypes.POLL,
        DeviationTypes.STATUS
    ].includes(deviationType);
    const rawContext = useContext(OverlayContext);
    const _ref = _object_spread({}, overlayContextDefaults, rawContext), { showTitle , showFaveControl , showCommentControl , showFaveEngagementIcon , showCommentEngagementIcon  } = _ref, restContext = _object_without_properties(_ref, [
        "showTitle",
        "showFaveControl",
        "showCommentControl",
        "showFaveEngagementIcon",
        "showCommentEngagementIcon"
    ]);
    return _object_spread({
        showTitle: canShowTitle && showTitle,
        showFaveControl: isFavouritable && showFaveControl,
        showCommentControl: isCommentable && showCommentControl,
        showFaveEngagementIcon: isFavouritable && showFaveControl && showFaveEngagementIcon,
        showCommentEngagementIcon: isCommentable && showCommentControl && showCommentEngagementIcon
    }, restContext);
}
export { OverlayContextProvider };
